import { Helmet } from "react-helmet-async";
import { ChevronDown } from "lucide-react";
import ScrollReveal from "@/components/ScrollReveal";

interface FAQItem { question: string; answer: string }
interface FAQProps { title?: string; subtitle?: string; items: FAQItem[]; bgClass?: string }

export default function FAQ({ title = "Frequently Asked Questions", subtitle, items, bgClass = "bg-white" }: FAQProps) {
  const faqSchema = {
    "@context": "https://schema.org", "@type": "FAQPage",
    mainEntity: items.map(item => ({ "@type": "Question", name: item.question, acceptedAnswer: { "@type": "Answer", text: item.answer } })),
  };
  return (
    <section className={`py-20 lg:py-28 ${bgClass}`}>
      <Helmet><script type="application/ld+json">{JSON.stringify(faqSchema).replace(/</g, "\\u003c")}</script></Helmet>
      <div className="container"><div className="max-w-3xl mx-auto">
        {subtitle && <ScrollReveal><p className="text-steel text-sm font-semibold uppercase tracking-[0.2em] mb-4">{subtitle}</p></ScrollReveal>}
        <ScrollReveal delay={0.1}><h2 className="text-3xl sm:text-4xl text-midnight mb-10">{title}</h2></ScrollReveal>
        <div className="space-y-3">
          {items.map((item, i) => (
            <ScrollReveal key={item.question} delay={i * 0.05}>
              <details className="group border border-border rounded overflow-hidden">
                <summary className="w-full flex items-center justify-between p-5 text-left hover:bg-pale/50 transition-colors cursor-pointer list-none [&::-webkit-details-marker]:hidden">
                  <span className="text-midnight font-medium text-sm sm:text-base pr-4">{item.question}</span>
                  <ChevronDown size={18} aria-hidden="true" className="text-steel flex-shrink-0 transition-transform duration-200 group-open:rotate-180" />
                </summary>
                <div className="px-5 pb-5 text-slate-brand text-sm leading-relaxed border-t border-border pt-4">{item.answer}</div>
              </details>
            </ScrollReveal>
          ))}
        </div>
      </div></div>
    </section>
  );
}
